// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c8eea917","952":"eb82f78b"}[chunkId] + ".chunk.js";
};